import { getListPickerConfigurationOption } from './listPickerConfiguration';
import { resolveListPickerTranslationKey } from './listPickerTranslationKeyResolver';

export function ListPickerSectionViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: true,
    isElementDeletable: true,
    initialize: function () {
      joint.shapes.html.AbstractElementView.prototype.initialize.apply(this, arguments);
      /*
       * Specific requirement for Apple messages.
       * https://alcmeon.atlassian.net/browse/SP-4726
       * type: 13 / type_name: "business-chat"
       */
      if (context.site.type === 13) {
        this.model.attr({ rect: { 'pointer-events': 'none' } });
      }
    },
    /**
     * Allows to disable the trash icon.
     * @example for whatsapp it is not possible to remove the last section because at least one is needed.
     */
    disableRemove: function () {
      const boxView = this._getBoxView();
      const sectionsMin = this.getConfigurationOption('min-section');
      return sectionsMin && boxView.numberOfSections === sectionsMin;
    },
    editElementModalController: 'editListPickerSectionController',
    editElementModalTemplate: require('./editListPickerSection.modal.html'),
    angularTemplate: `
    <div layout="row" class="alc-ellipsis">
        {{elementData.title || elementView.resolveTranslationKey('section_title_placeholder') | translate}}
    </div>
`,
    resolveTranslationKey: function (key) {
      return resolveListPickerTranslationKey(this.getParentType(), key);
    },
    getConfigurationOption: function (key) {
      return getListPickerConfigurationOption(this.getParentType(), key);
    },

    /**
     * Overriden from ElementView because we need to calculate sections we can delete.
     */
    removeElement: function () {
      const boxView = this._getBoxView();
      if (!boxView.numberOfSections || boxView.numberOfSections > 1) {
        boxView.numberOfSections--;
        this.model.remove();
        boxView.resizeBox();
      } else {
        services.AlertingFactory.warning('parameters/quick_replies/details/graph/list_picker_box/at_least_one_section_mandatory')
      }
    },

    _getBoxView: function () {
      const parent = this.model.getAncestors()[0];
      return this.paper.findViewByModel(parent);
    },
  });
}